<template>
  <div
    v-if="widget"
    class="hbt"
  >
    <div
      class="d-flex flex-wrap align-items-baseline"
      style="gap: 12px;"
    >
      <span class="hbt-kicker-mut">{{ widget.param.title || 'Выполнение плана по дням' }}</span>
      <span
        class="hbt-mut"
        style="margin-left: auto;"
      >среднее {{ avg }}% · дней 100%: {{ perfect }}</span>
    </div>
    <div
      class="hbt-month-grid"
      :style="{ gridTemplateColumns: `repeat(${cols}, 1fr)` }"
    >
      <div
        v-for="cell in cells"
        :key="cell.key"
        class="hbt-month-cell"
        :title="cell.title"
        :style="cell.style"
      >{{ cell.day }}</div>
    </div>
  </div>
</template>

<script>
import {
  HBT_REFRESH, hbtLoadHabits, hbtLoadLogs, hbtDayCompletion, hbtDayKey, hbtCellStyle,
} from '@/cubus/components/dashboard/habits/habitsCore'

export default {
  name: 'CbsWidgetHabitMonth',
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      habits: [],
      logs: [],
    }
  },
  computed: {
    days() {
      return Number(this.widget.param.days) || 30
    },
    cols() {
      return Number(this.widget.param.cols) || 10
    },
    dayList() {
      const list = []
      const d = new Date()
      d.setDate(d.getDate() - (this.days - 1))
      for (let i = 0; i < this.days; i += 1) {
        list.push({ key: hbtDayKey(d), day: d.getDate() })
        d.setDate(d.getDate() + 1)
      }
      return list
    },
    pcts() {
      return this.dayList.map(k => hbtDayCompletion(this.habits, this.logs, k.key).pct)
    },
    cells() {
      return this.dayList.map((k, i) => {
        const pct = this.pcts[i]
        const st = hbtCellStyle(pct)
        return {
          key: k.key,
          day: k.day,
          title: `${k.key}: ${pct}%`,
          style: { background: st.background, color: st.color, borderColor: st.borderColor },
        }
      })
    },
    avg() {
      if (!this.pcts.length) return 0
      return Math.round(this.pcts.reduce((a, b) => a + b, 0) / this.pcts.length)
    },
    perfect() {
      return this.pcts.filter(p => p >= 100).length
    },
  },
  created() {
    this.load()
    this.$root.$on(HBT_REFRESH, this.reload)
  },
  beforeDestroy() {
    this.$root.$off(HBT_REFRESH, this.reload)
  },
  methods: {
    async load() {
      this.habits = await hbtLoadHabits(this, this.widget.param)
      await this.reload()
    },
    async reload() {
      this.logs = await hbtLoadLogs(this, this.widget.param, this.days)
    },
  },
}
</script>

<style src="./habits/habits.css"></style>
<style scoped>
.hbt-month-grid {
  display: grid;
  gap: 6px;
  margin-top: 10px;
}
.hbt-month-cell {
  aspect-ratio: 1;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 800;
  border: 1px solid rgba(32, 30, 29, 0.4);
}
</style>
